module.exports = __webpack_public_path__ + "img/1_x2.827fcb30.png";